import {
  armyDoctor,
  homeBanner,
  markModal,
  medicalModal,
  physicalModal,
  physicalTrainer,
  spokenEnglishTrainer,
} from "../../assets/images";

export const aiMentorProfiles = [
  {
    name: "Anita Deshmukh",
    desc: "AI INET Mentor",
    profileButtonLink: `profile/chat?type=question&isRedirected=true`,
    chatButtonLink: "question",
    profilePic: homeBanner,
    profilePicMobile: homeBanner,
    features: [
      "Trained Mathematics, General Studies, and English teacher.",
      "Specialist in Student Psychology.",
      "Specialist in Defence and International Relations",
      "Trained Personality Development Coach..",
    ],
  },
  {
    name: "Ravinder Yadav",
    desc: "AI Medical Expert",
    profileButtonLink: `https://dev.ssbgpt.in/profile/medical-expert?rdtUrl=arinet-med`,
    chatButtonLink: "medical",
    profilePic: armyDoctor,
    profilePicMobile: medicalModal,
    features: [
      "Expert in military medical procedures.",
      "Trained on Medical Board data.",
      "AI-Enhanced Predictive Analysis.",
      "24/7 Virtual Medical Guidance.",
    ],
  },
  {
    name: "Mark",
    desc: "AI Spoken English Trainer",
    profileButtonLink: `https://dev.ssbgpt.in/profile/english-trainer?rdtUrl=arinet-eng`,
    chatButtonLink: "/spoken-english",
    profilePic: spokenEnglishTrainer,
    profilePicMobile: markModal,
    features: [
      "Language Assessments Expert.",
      "Responsive to Emotional Cues.",
      "Engaging Conversationalist.",
      "Empathetic Listener.",
    ],
  },
  {
    name: "Vikram Kumar",
    desc: "AI Fitness Trainer",
    profileButtonLink: `https://dev.ssbgpt.in/profile/fitness-coach?rdtUrl=arinet-fit`,
    chatButtonLink: "physical",
    profilePic: physicalTrainer,
    profilePicMobile: physicalModal,
    features: [
      "Expert in Creating Customized Workout Plans.",
      "Gives Real-Time Performance Feedback.",
      "Nutrition Guide.",
      "Injury Prevention and Recovery Expert.",
    ],
  },
];
